"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Button.scss");
var Button = function (props) { return (react_1.default.createElement("button", { type: props.type, disabled: props.disabled, className: classnames_1.default('button', { 'is-fullwidth': props.isFullWidth }, props.className), onClick: props.onClick }, props.children)); };
exports.Button = Button;
